
import { defineComponent } from "vue";
import TuitionDiscountsContent from "./components/TuitionDiscountsContent.vue";

export default defineComponent({
  name: "TuitionDiscountsPage",
  components: {
    TuitionDiscountsContent,
  },
});
